export default "__VITE_ASSET__BdrngVX2__"